
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-[#00F0FF]">
      <div className="px-5 md:px-12 py-10 md:py-16">
        <div className="flex flex-col items-center gap-5 md:gap-6">
          <div className="flex items-center gap-2">
            <span className="text-white text-xs font-light tracking-[0.3em]">NEW</span>
            <div className="w-px h-3 bg-[#00F0FF]"></div>
            <span className="text-white text-xs font-light tracking-[0.3em]">AGE CINEMA</span>
          </div>

          <p className="text-gray-500 text-xs font-mono">© 2025 EIJI HOSHINO</p>

          <nav className="flex items-center gap-6 md:gap-8">
            <Link
              to="/works"
              className="text-white text-xs font-light tracking-[0.2em] hover:text-[#00F0FF] transition-colors duration-300"
            >
              WORKS
            </Link>
            <Link
              to="/about"
              className="text-white text-xs font-light tracking-[0.2em] hover:text-[#00F0FF] transition-colors duration-300"
            >
              ABOUT
            </Link>
            <Link
              to="/contact"
              className="text-white text-xs font-light tracking-[0.2em] hover:text-[#00F0FF] transition-colors duration-300"
            >
              CONTACT
            </Link>
          </nav>

          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-600 text-xs hover:text-[#00F0FF] transition-colors duration-300 mt-4"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
